/**
 * Parse the group message list from a toList or to field.
 * @param toList The to list
 * @param to The to field.
 * @return List of numbers.
 */
export function parseGroupMessageList({ toList, to }) {
  if (toList) {
    return toList;
  }

  return parseNumberField(to);
}

/**
 * Parse a number field into a list.
 * @param number The potentially delimited number field.
 * @return List of numbers.
 */
export function parseNumberField(number) {
  const groupToList = [];
  const toPieces = number.split('+');

  if (toPieces.length > 1) {
    for (const toValue of toPieces) {
      if (toValue && toValue.length > 0) {
        // TODO: Add e164 format method similar to java code
        groupToList.push(`+${toValue}`);
      }
    }
  }
  else {
    groupToList.push(number);
  }

  return groupToList
}
